import { fetch } from '@/utils/request';

// 审核
const auditContentIndex = (param, callback) => fetch('/super/audit/content/index','GET',param, callback);

export default {
  auditContentIndex
}
